import QuestionsAndAnswers from './questionsAndAnswers';

export default QuestionsAndAnswers;
